import "core-js/modules/es.function.name";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';

var AppSnack = /*#__PURE__*/function (_Vue) {
  _inherits(AppSnack, _Vue);

  var _super = _createSuper(AppSnack);

  function AppSnack() {
    var _this;

    _classCallCheck(this, AppSnack);

    _this = _super.apply(this, arguments);
    _this.name = 'AppSnack';
    return _this;
  }

  _createClass(AppSnack, [{
    key: "showSnackbar",
    get: function get() {
      return this.snacks.length > 0;
    }
  }, {
    key: "snackMsg",
    get: function get() {
      var msg = this.snacks[0] ? this.snacks[0].msg : '';
      return msg;
    }
  }, {
    key: "snackColor",
    get: function get() {
      return this.snacks[0] ? this.snacks[0].type : '';
    }
  }]);

  return AppSnack;
}(Vue);

__decorate([State(function (state) {
  return state.snacks.snacks;
})], AppSnack.prototype, "snacks", void 0);

AppSnack = __decorate([Component], AppSnack);
export default AppSnack;